import Tooltip from '../../../Tooltip/Huuuge';
import { useState } from 'react';
import { ProductData } from '../../types';
import { StyledSubProduct } from '../style';
import { Box } from '@mui/material';

function BundleSubProduct({
    textFontColorHex,
    quantity,
    quantityDisplay,
    productType,
    index = 1,
    images,
    name = 'Product',
    rarityProductInfo,
    badgeText,
    itemRef
}: ProductData) {
    const [showTooltip, setShowTooltip] = useState(false);
    const [timeoutId, setTimeoutId] = useState<any>('');
    const tooltipIcon =
        'https://media-dev.appcharge.com/media/63e9ff6f062dde4c284603ca/image.png';

    const toggleTooltip = (e: any) => {
        if (!rarityProductInfo) return;
        e.stopPropagation();
        setShowTooltip(!showTooltip);
        if (showTooltip) {
            itemRef.current.removeAttribute('style');
        } else {
            itemRef.current.setAttribute('style', 'z-index: 2');
            if (timeoutId) clearTimeout(timeoutId);
            const timeout = setTimeout(() => {
                setShowTooltip(false);
                itemRef.current.removeAttribute('style');
            }, 2000);
            setTimeoutId(timeout);
        }
    };

    return (
        <StyledSubProduct
            color={textFontColorHex}
            isBadged={!!badgeText}
            badgeText={badgeText ? badgeText.substring(0, 2) : ''}
        >
            <Box className="content-container">
                <Box
                    className="product-image-container"
                    onClick={toggleTooltip}
                >
                    {rarityProductInfo && (
                        <img
                            src={tooltipIcon}
                            alt="tooltip"
                            className="tooltip"
                        />
                    )}
                    {badgeText && (
                        <Box className="badge">
                            <h4>{badgeText.substring(0, 2)}</h4>
                        </Box>
                    )}
                    <img
                        className="product"
                        src={images.product}
                        alt="product"
                    />
                </Box>
                <Box>
                    <p>{quantityDisplay}</p>
                    {rarityProductInfo && (
                        <p className="tooltip">
                            {rarityProductInfo.rarityText}{' '}
                            {Array.from(
                                { length: rarityProductInfo.stars },
                                (_, i) => {
                                    return (
                                        <img
                                            src="https://media-dev.appcharge.com/media/64ad4e96cc1a482bac46749c/Star_1.png"
                                            alt="star"
                                            key={i}
                                        />
                                    );
                                }
                            )}
                        </p>
                    )}
                </Box>
            </Box>
            {rarityProductInfo && (
                <Tooltip
                    productName={name}
                    productType={productType}
                    quantityDisplay={quantityDisplay}
                    productAmount={quantity as number}
                    tooltipText={rarityProductInfo.tooltipText}
                    rarityText={rarityProductInfo.rarityText}
                    stars={rarityProductInfo.stars}
                    display={showTooltip}
                    productIndex={index}
                />
            )}
        </StyledSubProduct>
    );
}

export default BundleSubProduct;
